import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {toast} from 'react-toastify'
import * as settingsAction from "store/entities/settingsInfo/action";
import { ButtonLoader } from '.';
import FormDrawer from '../form-drawer';

const UserPasswordResetModal = (props) => {
    const {isOpen, setIsOpen, data} = props;
    const dispatch = useDispatch();

    const { forgotPasswordMember, forgotPasswordMemberLoading} = useSelector((state) => state.entities.settingsInfo);


    const handleResetPassword = () => { 
        dispatch(settingsAction.forgotPasswordMember({email: data?.email}));
    }
    
    useEffect(() => {
        if(!forgotPasswordMember?.error && forgotPasswordMember?.message) {
            toast(forgotPasswordMember?.message);
            dispatch(settingsAction.forgotPasswordMemberStateReset())
            setIsOpen(false)
        }
    }, [forgotPasswordMember]);
 

    return (
        <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Reset Password"
                    showCloseButton={true}
                    close={() => setIsOpen()}
                />
                
                <div className='mt-4'>           
                    <div className='my-8'>
                        Are you sure you want to reset the password for this user? This action cannot be undone
                    </div>
                    <div className="p-1 mt-4 flex justify-end space-x-3 font-medium">
                        <button 
                            onClick={() => setIsOpen(false)} 
                            type="button" 
                            className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"
                        >
                            No
                        </button>
                        <ButtonLoader 
                            loading={forgotPasswordMemberLoading} 
                            onClick={handleResetPassword} 
                            type="button" 
                            className="btn btn-lg w-full rounded-lg whitespace-nowrap  text-white bg-ep-primary-600"
                        >
                            Yes
                        </ButtonLoader>
                    </div>     
                </div>
            </div>
        </FormDrawer>
    )
}

export default UserPasswordResetModal